module.exports = {
  VUE_APP_HOST: process.env.VUE_APP_HOST || 'localhost',
  VUE_APP_HTTP: process.env.VUE_APP_HTTP || 'http',
  VUE_APP_PORT: '3000',
  NODE_ENV: process.env.NODE_ENV
}
